module.exports = __webpack_public_path__ + "img/main-list_08.237a5b63.jpg";